import React, { Fragment } from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { usePageContext } from 'Context/PageContext';
import { useAppContext } from 'Context/ReactAppContext';
import type { LineProps } from 'Components/frameworks/line/Line';
import { FacebookAndTwitterSeoHeaderMeta } from 'Components/seo/FacebookAndTwitterSeoHeaderMeta';
import { BaiduSeoScript } from 'Components/third-party/BaiduSeoScript';
import { convertUrlToOrigin } from 'Utils/uri/uriUtils';
import URI from 'urijs';
const Line = dynamic(() => import('Components/frameworks/line/Line').then((m) => m.Line));
type Props = {
  noindex: Array<string>;
  page: {
    lines: LineProps[];
    tracking: LineProps;
    pageId: string;
  };
};
export const DynamicPage = ({ noindex, page }: Props) => {
  const { asPath } = useRouter();
  const { userAgent, originalUrl, locale } = useAppContext();
  const { canonicalUrl, pageDescription, pageTitle, pageType } = usePageContext();
  const origin = convertUrlToOrigin(originalUrl);
  const currentUri = origin + asPath;
  const canonicalURI = new URI(canonicalUrl);
  const canonicalPath = canonicalURI.path(true);
  return (
    <Fragment>
      <Head>
        {noindex.includes(canonicalPath) && <meta name="robots" content="noindex" />}
        <BaiduSeoScript
          lines={page.lines}
          locale={locale}
          userAgent={userAgent}
          originalUrl={originalUrl}
          pageTitle={pageTitle}
          pageType={pageType}
          pageDescription={pageDescription}
        />
      </Head>
      <FacebookAndTwitterSeoHeaderMeta
        description={pageDescription}
        lines={page.lines}
        pageType={pageType}
        title={pageTitle}
        url={currentUri.toString()}
      />
      <main role="main">
        <Line {...page.tracking} />
        {page.lines.map((line) => (
          <Line {...line} key={line.id} pageLines={page.lines} />
        ))}
      </main>
    </Fragment>
  );
};
DynamicPage.pageId = 'DYNAMIC_PAGE';
DynamicPage.pageType = 'DYNAMIC_PAGE';
